import { useState } from 'react';
import { api, ApiError, type Me } from '../api.js';

export function Login({ onSignedIn }: { onSignedIn: (me: Me) => void }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  return (
    <main className="page narrow">
      <h1>Logbook</h1>
      <form onSubmit={async (e) => {
        e.preventDefault();
        setError(null);
        try { onSignedIn((await api<{ user: Me }>('POST', '/api/auth/login', { email, password })).user); }
        catch (err) { setError((err as ApiError).message); }
      }}>
        <label>E-mail<input type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} required /></label>
        <label>Password<input type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required /></label>
        {error && <p className="error" role="alert">{error}</p>}
        <button type="submit">Sign in</button>
      </form>
    </main>
  );
}
